import { ALERT_DANGER, CALYPSO_DARK, CALYPSO_MEDIUM, CIRRUS, FLINT, HEFFALUMP, MARIGOLD, OLAF, TRANSPARENT } from 'HubStyleTokens/colors';
export const BUILDER_CARD_TITLE_BAR_USES = ['calypso', 'koala', 'heffalump', 'marigold', 'norman', 'oz', 'sorbet', 'thunderdome'];
export const BUILDER_CARD_BORDER_COLOR_DEFAULT = FLINT;
export const BUILDER_CARD_BORDER_COLOR_ERROR = ALERT_DANGER;
export const BUILDER_CARD_BORDER_COLOR_INFO = FLINT;
export const BUILDER_CARD_BORDER_COLOR_WARNING = MARIGOLD;
export const BUILDER_CARD_STATUS_INDICATOR_COLOR_DEFAULT = TRANSPARENT;
export const BUILDER_CARD_STATUS_INDICATOR_COLOR_ERROR = ALERT_DANGER;
export const BUILDER_CARD_STATUS_INDICATOR_COLOR_INFO = CALYPSO_MEDIUM;
export const BUILDER_CARD_STATUS_INDICATOR_COLOR_WARNING = MARIGOLD;
export const BUILDER_CARD_BACKGROUND_COLOR = OLAF;
export const BUILDER_CARD_BACKGROUND_COLOR_HOVERED = CIRRUS;
export const BUILDER_CARD_BOX_SHADOW_HOVERED = CALYPSO_DARK;
export const BUILDER_CARD_BORDER_COLOR_HOVERED = CALYPSO_DARK;
export const BUILDER_CARD_TITLE_BAR_BACKGROUND_COLOR_DEFAULT = HEFFALUMP;